import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    closeDialog: any;
    isSuccess: boolean;
    errorResponse: any;
}

const CCAMConfirmationDialog: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();

    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => { });
        };
    });

    const getErrorMessage = () => {
        if (props.errorResponse.code === "35" || props.errorResponse.code === "36") {
            return <>
                {tLang("credit.creditActivity.code35or36ErrorMsg1")}{" "}
                <a href="https://www.transunion.com/credit-freeze/credit-freeze-faq#freeze-other" target="_blank" rel="noopener noreferrer">{tLang("credit.creditActivity.code35or36ErrorMsgLink")}</a>{" "}
                {tLang("credit.creditActivity.code35or36ErrorMsg2")}
            </>
        } else if (props.errorResponse.code === "27") {
            return tLang("credit.creditActivity.code27ErrorMsg");
        } else if (props.errorResponse.code === "551") {
            return tLang("credit.creditActivity.code551ErrorMsg");
        }
        return tLang("credit.creditActivity.defaultErrorMsg");
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>{props.isSuccess ? "Success" : "Failure"}</h1>
            </div>

            <div className="dialog-body">
                <p>
                    {props.isSuccess
                        ? tLang("credit.creditActivity.successMessage")
                        : getErrorMessage()
                    }
                </p>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            className="btn-default btn-primary"
                            id="btn-submit-upgrade-confirmation"
                            onClick={() => {
                                props.closeDialog();
                            }}
                        >
                            <span className="btn-text">{props.isSuccess ? "Done" : "Ok"}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default CCAMConfirmationDialog;
